module.exports = __webpack_public_path__ + "static/media/jeerarice.b64ea0aa.jpg";